import { ListLocaleModel, useListLocaleFunctionRequest } from "../../request/myHealthyAdvantageApi";

export function useDefaultLocaleId() {
  const { data: localeList } = useListLocaleFunctionRequest();

  return localeList && localeList.locales ? localeList.locales.find((locale: ListLocaleModel) => locale.defaultValue)?.id : undefined;
}
